// src/ArrowBoxUpIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ArrowBoxUpIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "40",
    height: "41",
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.4 0.529297H11.64C4.36002 0.529297 0.0200195 4.8693 0.0200195 12.1493V28.8893C0.0200195 36.1893 4.36002 40.5293 11.64 40.5293H28.38C35.66 40.5293 40 36.1893 40 28.9093V12.1493C40.02 4.8693 35.68 0.529297 28.4 0.529297Z",
          fill: "#0095E4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M29.66 18.1693C29.08 18.7493 28.12 18.7493 27.54 18.1693L21.52 12.1493V32.5293C21.52 33.3493 20.84 34.0293 20.02 34.0293C19.2 34.0293 18.52 33.3493 18.52 32.5293V12.1493L12.5 18.1693C11.92 18.7493 10.96 18.7493 10.38 18.1693C10.08 17.8693 9.94002 17.4893 9.94002 17.1093C9.94002 16.7293 10.1 16.3293 10.38 16.0493L18.96 7.4693C19.24 7.1893 19.62 7.0293 20.02 7.0293C20.42 7.0293 20.8 7.1893 21.08 7.4693L29.66 16.0493C30.24 16.6293 30.24 17.5693 29.66 18.1693Z",
          fill: "white"
        }
      )
    ]
  }
);
var ArrowBoxUpIcon_default = ArrowBoxUpIcon;

export {
  ArrowBoxUpIcon_default
};
